import { useState } from 'react';

import { Button, Checkbox, Modal } from 'antd';

import { ReactComponent as UpdateSubscription } from '@/layouts/subscription/src/UpdateSubscription.svg';
import client from '@/lib/http/client';

type TProps = {
	openModalCredits: boolean;
	handleModalCredits: () => void;
};

export default function UpdateSubscriptionModal({
	openModalCredits,
	handleModalCredits,
}: TProps) {
	const [checked, setChecked] = useState(false);
	const [isLoading, setIsLoading] = useState(false);

	const onCheckboxChange = (e: any) => {
		setIsLoading(true);

		client
			.put('/users/update-do-not-remind-subscription', {
				value: e.target.checked,
			})
			.then((response) => {
				if (response.data?.success) {
					localStorage.setItem(
						'do-not-remind-subscription',
						response.data?.value ? '1' : '0',
					);
					setChecked(response.data?.value || false);
				} else {
					localStorage.setItem('do-not-remind-subscription', '0');
					setChecked(false);
				}
			})
			.catch((error) => {
				console.error('Error updating subscription modal:', error);
			})
			.finally(() => {
				setIsLoading(false);
			});
	};

	return (
		<Modal
			destroyOnClose
			open={openModalCredits}
			centered
			title="Update subscription"
			// onOk={}
			onCancel={handleModalCredits}
			footer={[]}
			width={800}
		>
			<div style={{ display: 'flex', padding: '30px' }}>
				<div style={{ flex: '1 1 0' }}>
					<UpdateSubscription />
				</div>

				<div
					style={{
						flex: '1 1 0',
						display: 'flex',
						flexDirection: 'column',
						justifyContent: 'center',
					}}
				>
					<p
						style={{
							fontSize: '1.7rem',
						}}
					>
						No credits remaining - please ask your system administrator to top
						up to continue !
					</p>
					<Button
						key="back"
						type="primary"
						onClick={handleModalCredits}
						style={{ width: 'fit-content', alignSelf: 'end' }}
					>
						Close
					</Button>
					<div style={{ marginTop: '2rem' }}>
						<Checkbox
							checked={checked}
							onChange={onCheckboxChange}
							disabled={isLoading}
						>
							Don't remind me again
						</Checkbox>
					</div>
				</div>
			</div>
		</Modal>
	);
}
// import React, { Suspense } from 'react';
